import { render, staticRenderFns } from "./TariffRegionListPage.vue?vue&type=template&id=47c9b6bc&"
import script from "./TariffRegionListPage.vue?vue&type=script&lang=ts&"
export * from "./TariffRegionListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports